import listComponent from '.';
import API from './api';
import formComponent from './form';

export default (MODULE) => {
  API(MODULE);
  
  const resolver = function (response) {
    if (response.data) {
      const data = response.data;
      if (data.error) return this.reject(data.error);
      return this.resolve(data);
    } else {
      throw new Error('Invalid server response');
    }
  };

  /* @ngInject */
  const resolve = {
    // pulled from legacy
    'allowed': AppCtrl.authResolver,
    'company': (allowed, $q, $rootScope) => {
      const deferred = $q.defer();
      deferred.resolve($rootScope.user.activeCompany());
      return deferred.promise;
    }
  };

  const GiftFormComponent = formComponent(MODULE);
  const GiftListComponent = listComponent(MODULE);

  angular.module(MODULE)
    /* @ngInject */
    .config(($stateProvider) => {
      $stateProvider
        .state('listPrepayments', {
          url: '/prepayments/:type/page/:page',
          auth: true,
          component: GiftListComponent,
          resolve: Object.assign(resolve, {
            tran: ($q, $transition$) => {
              const deferred = $q.defer();
              deferred.resolve($transition$.params("to"));
              return deferred.promise;
            },
            gifts: (company, $q, $transition$, GiftAPI) => {
              const deferred = $q.defer();
              const toParams = $transition$.params("to");
              const API = GiftAPI.req();
              let type = 'card';
              switch (toParams.type) {
                case 'gift':
                  type = 'card';
                  break;
                case 'promo':
                case 'promotion':
                  type = 'promo';
                  break;
                default:
                  type = toParams.type;
              }
              const Gifts = API.list({ type: type, page: toParams.page || 1 }).$promise;
              Gifts.then((gifts) => {
                deferred.resolve(Object.assign({}, gifts, { page: toParams.page || 1, type }));
              });
              return deferred.promise;
            }
          })
        })
        .state('editPrepayment', {
          url: '/prepayments/:id',
          auth: true,
          component: GiftFormComponent,
          resolve: Object.assign(resolve, {
            gift: (company, $q, $transition$, GiftAPI) => {
              const deferred = $q.defer();
              const toParams = $transition$.params("to");
              const API = GiftAPI.req();
              const Gift = API.view({ id: toParams.id }).$promise;
              Gift.then((gift) => {

                if (gift.type === 'card' && !gift.electronic) {
                  gift.shipping = gift.shipping || 2.5;
                }

                deferred.resolve(gift);
              });
              return deferred.promise;
            },
          })
        })
        .state('newPrepayment', {
          url: '/prepayments/new/:type',
          auth: true,
          component: GiftFormComponent,
          resolve: Object.assign(resolve, {
            gift: (company, $q) => {
              const deferred = $q.defer();
              deferred.resolve({});
              return deferred.promise;
            },
            token: (gift, $q, $transition$, GiftAPI) => {
              const toParams = $transition$.params("to");
              const API = GiftAPI.req();
              const token = API.token().$promise;
              const deferred = $q.defer();
              token.then((tok) => {
                gift.type = toParams.type || 'gift';
                gift.code = tok.code;
                deferred.resolve(gift);
              });
              return deferred.promise;
            }
          })
        })
    });

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/route.js